import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '@shared/services/auth.service';

export const isAuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isAuthenticated()
    ? true
    : router.createUrlTree(['/login']);
};

export const isNotAuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return !authService.isAuthenticated()
    ? true
    : router.createUrlTree(['/home']);
};

export const hasClaimGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredClaim = next.data['claim'];

  return authService.getUserPermissions().pipe(
    map((claims) => {
      if (!requiredClaim || claims.includes(requiredClaim)) {
        return true;
      }

      return router.createUrlTree(['/home']);
    }),
    catchError((err) => {
      console.error('Erro ao verificar permissões:', err);
      return of(router.createUrlTree(['/home']));
    })
  );
};
